import { getLoginPath } from '@/utils/uri';

const CHAMGE_PWD_SYMBOL = 'ON_CHANGE_PASSWORD';

const handleCrossTabChange = (ev: StorageEvent) => {
  if (ev.key === CHAMGE_PWD_SYMBOL) {
    // removeItem同样触发storage事件，此时ev.newValue为空
    if (!ev.newValue)
      return;
    window.location.href = getLoginPath();
  }
};

export default class ChangePwdCrossTab {
  static registiry() {
    window.addEventListener('storage', handleCrossTabChange);
  }

  static unregistiry() {
    window.removeEventListener('storage', handleCrossTabChange);
  }

  static sendMessage() {
    localStorage.setItem(CHAMGE_PWD_SYMBOL, CHAMGE_PWD_SYMBOL);
    localStorage.removeItem(CHAMGE_PWD_SYMBOL);
  };
}

(window as any).sendMessage = ChangePwdCrossTab.sendMessage;